module.exports = __webpack_public_path__ + "img/wild5.26cac617.png";